import RewardsList from './RewardsList';

export default RewardsList;
